import { Collection } from "../ports.js";
/** Where the household's agent found an answer: the owner typed it, it was in this need's words, or a past job's. */
export const AnswerSource = { owner: "owner", words: "words", memory: "memory" };
export const TaskKind = {
    /** The agents reached terms; sign them, or decline. */
    confirmDeal: "confirm_deal",
    /** The worker asked something the agent could not answer from the need. */
    answerQuestions: "answer_questions",
    /** The consumer says they paid; confirm the money arrived, or dispute it. */
    confirmPayment: "confirm_payment",
    /** A request has a detail the worker asked to see first (pets, say): take it, or decline. */
    approveRequest: "approve_request",
    /** The agents used their offers without agreeing (ADR 0053 §4): accept theirs, send a final offer, or end it. */
    takeOver: "take_over",
    /** The worker proposes another time, or the time asked for has passed (ADR 0053 §3): accept, pick, or decline. */
    newTime: "new_time",
};
export const taskId = (kind, engagement) => `${kind}|${engagement}`;
/** The device's job records, needs and owner tasks, over the Storage port. */
export class JobStore {
    storage;
    constructor(storage) {
        this.storage = storage;
    }
    job(id) {
        return this.storage.get(Collection.jobs, id);
    }
    saveJob(r) {
        return this.storage.put(Collection.jobs, r.engagement.id, r);
    }
    async jobs() {
        const all = await this.storage.list(Collection.jobs);
        return all.sort((a, b) => a.engagement.created_at.localeCompare(b.engagement.created_at));
    }
    async group(group) {
        return (await this.jobs()).filter((r) => r.engagement.group === group);
    }
    need(group) {
        return this.storage.get(Collection.needs, group);
    }
    saveNeed(n) {
        return this.storage.put(Collection.needs, n.group, n);
    }
    addTask(kind, engagement, detail, at) {
        const id = taskId(kind, engagement);
        return this.storage.put(Collection.tasks, id, {
            id,
            kind,
            engagement,
            detail,
            created_at: at.toISOString(),
        });
    }
    task(kind, engagement) {
        return this.storage.get(Collection.tasks, taskId(kind, engagement));
    }
    removeTask(kind, engagement) {
        return this.storage.delete(Collection.tasks, taskId(kind, engagement));
    }
    async tasks() {
        const all = await this.storage.list(Collection.tasks);
        return all.sort((a, b) => a.created_at.localeCompare(b.created_at));
    }
}
//# sourceMappingURL=store.js.map